<template>
  <span
    class="ui-text-clickable"
    :class="{ shade: shade, disabled: disabled, 'pa-4': pa, 'px-4': px }"
    @click="click"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: "HiClickable",
  props: {
    shade: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    pa: {
      type: Boolean
    },
    px: {
      type: Boolean
    }
  },
  methods: {
    click() {
      if (this.disabled) return;
      this.$emit("click");
      // this.isDisabled = true;
    }
  }
};
</script>

<style scoped>
.disabled {
  opacity: 0.4;
  cursor: default;
  pointer-events: none;
}
</style>
